
import { Field as HeadlessField } from "@headlessui/react";

import { cn } from "../lib/utils";

function Field( { className, ...props } ) {
  
  return (

    <HeadlessField

      className={ cn( "flex items-center gap-2.5", className ) }

      { ...props }  

    />

  )

}

export { Field }
